import React from 'react';
import "./modal.css"




 
const Modal = (props) => {

    function closeModal(){
        props.close()
    }

  
   
    
    return <> 
 <div className='modalContainer'>
  <div className='closeButton'>   <div className='closeButtonBox' onClick={closeModal}><svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.39353 0.292893C1.78405 -0.0976311 2.41722 -0.0976311 2.80774 0.292893L14.8286 12.3137C15.2191 12.7042 15.2191 13.3374 14.8286 13.7279L14.5517 14.0048C14.1611 14.3953 13.528 14.3953 13.1374 14.0048L1.11662 1.98401C0.726099 1.59349 0.7261 0.960322 1.11662 0.569797L1.39353 0.292893Z" fill="#CC0033"/>
    <path d="M14.5519 0.292893C14.1614 -0.0976311 13.5282 -0.0976311 13.1377 0.292893L1.11685 12.3137C0.726329 12.7042 0.726329 13.3374 1.11685 13.7279L1.39376 14.0048C1.78428 14.3953 2.41745 14.3953 2.80797 14.0048L14.8288 1.98401C15.2193 1.59349 15.2193 0.960322 14.8288 0.569797L14.5519 0.292893Z" fill="#CC0033"/>
    </svg></div></div>
  <div className='modalContent'>{props.children}</div>
    </div>
   
    </>;
    }

export default Modal;
